export const environment = {
  production: true,
  baseURL: "/api",
  LOGIN : true
};
